import styled from 'styled-components';

const ProductDetailsWrapper = styled.div`
  ${(p: { isCis: boolean; theme }) => `
    margin-top: -${p.isCis ? p.theme.spacing(3) : 0}
  `};
  ${p => p.theme.media.md`
    margin-top: -${p.isCis ? p.theme.spacing(6) : 0}
  `};
`;

export { ProductDetailsWrapper };
